import type {
  ExtendedShippedItem,
  TicketGroup,
} from '@interfaces/ticketevolution/tikets';

/**
 * Checks whether a ticket listing offers mobile / electronic delivery.
 * Returns false for physical tickets (courier/FedEx/local pickup).
 */
export function isMobileTicket(
  ticket?: Partial<ExtendedShippedItem & TicketGroup> | null
): boolean {
  if (!ticket) return false;

  const format = String(ticket.format || '').toLowerCase();
  const type = String(ticket.type || '').toLowerCase();

  // Explicit physical delivery excludes mobile
  if (
    format === 'physical' ||
    type === 'fedex' ||
    type === 'localpickup' ||
    format === 'paper' ||
    format === 'hard'
  ) {
    return false;
  }

  // Explicit eticket boolean flag from Ticket Evolution (true for mobile/electronic, false for physical)
  if (ticket.eticket === true) return true;
  if (ticket.eticket === false && !format && !type) return false;

  // Format indicators (e.g. TM_mobile, Flash_seats, Paperless, Eticket)
  if (
    format.includes('mobile') ||
    format.includes('tm_mobile') ||
    format.includes('flash') ||
    format.includes('paperless') ||
    format.includes('eticket')
  ) {
    return true;
  }

  // Mapped shipment type indicators (e.g. TMMobile, FlashSeats, Paperless, Eticket)
  if (
    type.includes('mobile') ||
    type.includes('tmmobile') ||
    type.includes('flash') ||
    type.includes('paperless') ||
    type.includes('eticket')
  ) {
    return true;
  }

  // Fallback: check public notes
  const notes = String(
    (ticket as ExtendedShippedItem).publicNotes ||
      (ticket as TicketGroup).public_notes ||
      ''
  ).toLowerCase();
  if (
    notes.includes('scan your tickets from your mobile phone') ||
    notes.includes('mobile ticket') ||
    notes.includes('mobile entry') ||
    notes.includes('eticket')
  ) {
    return true;
  }

  return false;
}
